import api from "./api";

export default {
  getAll: () => api.get("/fretes"),
  getById: (id) => api.get(`/fretes/${id}`),
  create: (data) => api.post("/fretes", { frete: data }),
  update: (id, data) => api.put(`/fretes/${id}`, { frete: data }),
  destroy: (id) => api.delete(`/fretes/${id}`),
};
